import { useContext } from 'react';
import { ApiContext } from '../App';

export default function useApiClient() {
  const context = useContext(ApiContext);
  if (context === undefined) {
    throw new Error('useApi must be used within an ApiProvider (which must be within an AuthProvider)');
  }
  return { apiClient : context.axiosClient };
}
